import { render } from "./ModSecurityPanel.vue?vue&type=template&id=4fed2fe2&scoped=true"
import script from "./ModSecurityPanel.vue?vue&type=script&lang=js"
export * from "./ModSecurityPanel.vue?vue&type=script&lang=js"

import "./ModSecurityPanel.vue?vue&type=style&index=0&id=4fed2fe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed2fe2"]])

export default __exports__